export default {
    workOrder_tab_advancedFilters_title: "Filtros Avanzados",
    workOrder_tab_advancedFilters_clearAll: "Limpiar",
    workOrder_tab_advancedFilters_status: "Estado",
    workOrder_tab_advancedFilters_scheduledDate: "Fecha Programada",
    workOrder_tab_advancedFilters_type: "Tipo",
    workOrder_tab_advancedFilters_severity: "Severidad",
    workOrder_tab_advancedFilters_driver: "Conductor",
};